import {defineStore} from 'pinia';

export const useLoadingStore = defineStore('loading', {
    state: () => ({
        isLoading: false,
        message: '',
        subMessage: '',
        loadingStack: [] // Track multiple loading states
    }),

    actions: {
        showLoading(message = '', subMessage = '') {
            this.isLoading = true;
            this.message = message;
            this.subMessage = subMessage;

            // Add to stack for nested loading states
            this.loadingStack.push({message, subMessage});
        },

        hideLoading() {
            // Remove from stack
            this.loadingStack.pop();

            if (this.loadingStack.length > 0) {
                // Show previous loading state
                const current = this.loadingStack[this.loadingStack.length - 1];
                this.message = current.message;
                this.subMessage = current.subMessage;
            } else {
                // No more loading states
                this.message = '';
                this.subMessage = '';
                this.isLoading = false;
            }
        },

        updateLoadingMessage(message, subMessage = '') {
            if (this.isLoading) {
                this.message = message;
                this.subMessage = subMessage;

                // Update current stack item
                if (this.loadingStack.length > 0) {
                    this.loadingStack[this.loadingStack.length - 1] = {message, subMessage};
                }
            }
        },

        forceHideLoading() {
            this.isLoading = false;
            this.message = '';
            this.subMessage = '';
            this.loadingStack = [];
        }
    }
});
